<template>
  <div class="form-view">
    <div class="content-list-view">
      <!-- 生产经营 -->
      <el-form
        :model="SCJYForm"
        class="login-form"
        ref="SCJYForm"
        label-width="184px"
        :disabled="editState"
      >
        <el-form-item label="主营业务及产品说明:">
          <el-input
            style="width: 440px"
            type="textarea"
            placeholder="请输入主营业务及产品说明"
            v-model="SCJYForm.zyywjcpsm"
            maxlength="300"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="主营业务规模:">
          <el-select
            style="width: 240px"
            v-model="SCJYForm.zyywgm"
            placeholder="请选择主营业务规模"
          >
            <el-option
              v-for="item in zyywgmList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有无技术改造项目:">
          <el-radio-group v-model="SCJYForm.ywjsgzxm">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有无境外投资项目:">
          <el-radio-group v-model="SCJYForm.ywjwtzxm">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="纳税规模:">
          <el-select
            style="width: 240px"
            v-model="SCJYForm.nsgm"
            placeholder="请选择纳税规模"
          >
            <el-option
              v-for="item in nsgmList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实缴税金（万元）:">
          <el-input
            style="width: 240px"
            v-model="SCJYForm.sjzj"
            placeholder="请输入实缴税金"
            maxlength="12"
            @input="numberTemplate($event, 'sjzj')"
          ></el-input>
        </el-form-item>
        <el-form-item label="净资产（万元）:">
          <el-input
            style="width: 240px"
            v-model="SCJYForm.jzc"
            placeholder="请输入净资产"
            maxlength="12"
            @input="numberTemplate($event, 'jzc')"
          ></el-input>
        </el-form-item>
        <el-form-item label="销售收入（万元）:">
          <el-input
            style="width: 240px"
            v-model="SCJYForm.xssr"
            placeholder="请输入销售收入"
            maxlength="12"
            @input="numberTemplate($event, 'xssr')"
          ></el-input>
        </el-form-item>
        <el-form-item label="营业收入（万元）:">
          <el-input
            style="width: 240px"
            v-model="SCJYForm.yysr"
            placeholder="请输入营业收入"
            maxlength="12"
            @input="numberTemplate($event, 'yysr')"
          ></el-input>
        </el-form-item>
        <el-form-item label="研发经费支出（万元）:">
          <el-input
            style="width: 240px"
            v-model="SCJYForm.yfjfzc"
            placeholder="请输入研发经费支出"
            maxlength="12"
            @input="numberTemplate($event, 'yfjfzc')"
          ></el-input>
        </el-form-item>
        <el-form-item label="净利润（万元）:">
          <el-input
            style="width: 240px"
            v-model="SCJYForm.jlr"
            placeholder="请输入净利润"
            maxlength="12"
            @input="numberTemplate($event, 'jlr')"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="control-view">
      <el-button
        type="primary"
        style="margin-top: 10px; padding: 10px 27px"
        @click="editForm"
        v-if="editState"
      >
        编辑
      </el-button>
      <el-button
        type="primary"
        style="margin-top: 10px; padding: 10px 27px"
        v-if="!editState"
        @click="saveInfo"
      >
        保存
      </el-button>
    </div>
  </div>
</template>

<script>
import { getRegisterUserEdit, getByToken2 } from "@/api/app";
import SCJY from "@/views/register/modules/SCJY";
export default {
  mixins: [SCJY],
  data() {
    return {
      editState: true
    };
  },
  beforeMount() {
    this.getByToken2();
  },
  methods: {
    editForm() {
      this.editState = false;
    },
    async getByToken2() {
      let { data } = await getByToken2();
      let params = {};
      for (const key in this.SCJYForm) {
        if (data[key]) {
          params[key] = data[key];
        }
      }
      this.SCJYForm = Object.assign({}, this.SCJYForm, params);
    },
    /**提交 */
    saveInfo() {
      this.$refs["SCJYForm"].validate(async valid => {
        if (valid) {
          this.loading = true;
          let params = Object.assign({}, this.SCJYForm);
          getRegisterUserEdit(params)
            .then(res => {
              if (res.data) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.editState = true;
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.control-view {
  padding-left: 320px;
  & .el-button {
    background: rgba(41, 99, 204, 1);
    border-color: rgba(41, 99, 204, 1);
  }
}
</style>
